<template>
  <v-tab-item :id="'4'" style="width: 100%; height: 500px">
    <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>
    <v-card>
      <v-flex xs12 sm12 md12 pa-2>
        <v-form ref="formChildAge" v-model="validRate" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12 sm6 md3>
              <v-select
                v-model="params.ChildAgeStart"
                :items="cocukSayiItems"
                label="Çocuk Başlangıç yaşı"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-select
                v-model="params.ChildAgeEnd"
                :items="cocukSayiItems"
                label="Çocuk Bitiş yaşı"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                label="Yüzde"
                v-model="params.Percent"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-btn block color="primary" @click="saveChildPrice()" dark
                >Ekle</v-btn
              >
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>

      <v-flex xs12 sm12 md12 pa-2>
        <v-flex xs12 sm12 md12 pa-2>
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            class="elevation-1"
            item-key="id"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.childCount }} . Çocuk</td>
              <td class="text-xs-left">{{ props.item.childAgeStart }}</td>
              <td class="text-xs-left">{{ props.item.childAgeEnd }}</td>
              <td class="text-xs-left">{{ props.item.percent }}</td>
              <td class="text-xs-left">
                <v-btn
                  flat
                  icon
                  small
                  @click="editChildPrice(props.item)"
                  color="primary"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  flat
                  icon
                  small
                  @click="deleteChildPrice(props.item.id)"
                  color="primary"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-flex>
    </v-card>

    <v-layout row justify-center>
      <v-dialog v-model="editChildPriceDialog" persistent max-width="900px">
        <v-card>
          <v-card-title>
            <span class="headline">Çocuk Fiyat Güncelle</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-flex xs12 sm12 md12 pa-2>
                <v-form
                  ref="formchildPriceDialog"
                  v-model="validRate"
                  lazy-validation
                >
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md3>
                      <v-select
                        v-model="updateParams.ChildAgeStart"
                        :items="cocukSayiItems"
                        label="Çocuk Başlangıç yaşı"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-select
                        v-model="updateParams.ChildAgeEnd"
                        :items="cocukSayiItems"
                        label="Çocuk Bitiş yaşı"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        label="Yüzde"
                        v-model="updateParams.Percent"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click.native="editChildPriceDialog = false"
              >Kapat</v-btn
            >
            <v-btn color="blue darken-1" flat @click="updateChildPrice()"
              >Güncelle</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-tab-item>
</template>


<script>
import auth from "@/api/auth.js";
import loadingcomp from "@/components/app/customcomp/loadingcomp"

export default {
  props: {
    isChoosen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingvmodel:false,
      cocukSayiItems: [
        {
          text: "1 yaş ve altı",
          value: 1,
        },
        {
          text: "2",
          value: 2,
        },
        {
          text: "3",
          value: 3,
        },
        {
          text: "4",
          value: 4,
        },
        {
          text: "5",
          value: 5,
        },
        {
          text: "6",
          value: 6,
        },
        {
          text: "7",
          value: 7,
        },
        {
          text: "8",
          value: 8,
        },
        {
          text: "9",
          value: 9,
        },
        {
          text: "10",
          value: 10,
        },
        {
          text: "11",
          value: 11,
        },
        {
          text: "12",
          value: 12,
        },
        {
          text: "13",
          value: 13,
        },
        {
          text: "14",
          value: 14,
        },
        {
          text: "15",
          value: 15,
        },
        {
          text: "16",
          value: 16,
        },
        {
          text: "17",
          value: 17,
        },
        {
          text: "18",
          value: 18,
        },
      ],
      params: {
        Ref: 0,
        Percent: 0,
        ChildAgeStart: 0,
        ChildAgeEnd:0,
        ChildCount: 0,
        OtelId: 0,
      },
      updateParams: {
        Ref: 0,
        Percent: 0,
        ChildAgeStart: 0,
        ChildAgeEnd:0,
        ChildCount: 0,
        OtelId: 0,
      },
      editChildPriceDialog: false,
      validRate: true,
      valid: true,
      items: [],
      headers: [
        {
          text: "Çocuk Sayı",
        },
        {
          text: "Çocuk Başlangıç Yaş",
        },
        {
          text: "Çocuk Bitiş Yaş",
        },
        {
          text: "Yüzde",
        },
        {
          text: "İşlem",
        },
      ]
    };
  },
  watch: {
    isChoosen: function () {
      if (this.isChoosen) {
        this.getChildPriceList();
      }
    },
  },
  methods: {
    updateChildPrice() {
      if (this.$refs.formchildPriceDialog.validate()) {
        this.loadingvmodel = true;
        this.updateParams.OtelId = this.$route.query.kod;

        var params = this.updateParams;

        this.$http
          .post(auth.HOTELRUNNER_API_URL + "api/v1/UpdateChildPrices", params, {
            headers: {
              Authorization:
                "Basic " +
                window.btoa(
                  auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                ),
            },
          })
          .then(
            (response) => {
              this.text1 = response.body.Message;
              this.snackbar = true;
              this.getChildPriceList();
              this.loadingvmodel = false;
              this.editChildPriceDialog = false;
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-UpdateChildPrices";
                this.snackbar = true;
                this.loadingvmodel = false;
                this.editChildPriceDialog = false;
              } else {
                this.text1 = "Service Unavailable-UpdateChildPrices";
                this.snackbar = true;
                this.loadingvmodel = false;
                this.editChildPriceDialog = false;
              }
            }
          );
      }
    },
    editChildPrice(childPrice) {
      this.updateParams.Ref = childPrice.id;
      this.updateParams.Percent = childPrice.percent;
      this.updateParams.ChildAge = childPrice.childAge;
      this.updateParams.ChildCount = childPrice.childCount;
      this.updateParams.OtelId = this.$route.query.kod;

      this.editChildPriceDialog = true;
    },
    deleteChildPrice(id) {
      this.loadingvmodel = true;
      var params = {
        Ref: id,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/DeleteChildPrices", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            if (response.body.status) {
              this.getChildPriceList();
              this.loadingvmodel = false;
            } else {
              this.text1 = response.body.message;
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-DeleteRateProperty";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-DeleteRateProperty";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getChildPriceList() {
      this.loadingvmodel = true;


      var params = {
        OtelId: this.$route.query.kod,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/ChildPriceList", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.items = [];
            this.items = response.body;
            this.loadingvmodel = false;

          },
          (response) => {
            if (response.status === 0) {
              this.text1 =
                "Service Unavailable-ChildPriceList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 =
                "Service Unavailable-ChildPriceList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    saveChildPrice() {
      if (this.$refs.formChildAge.validate()) {
        this.loadingvmodel = true;
        this.params.ChildCount = this.items.length + 1;
        this.params.OtelId = this.$route.query.kod;

        var params = this.params;

        this.$http
          .post(auth.HOTELRUNNER_API_URL + "api/v1/AddChildPrices", params, {
            headers: {
              Authorization:
                "Basic " +
                window.btoa(
                  auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                ),
            },
          })
          .then(
            (response) => {
              this.text1 = response.body.Message;
              this.snackbar = true;
              this.getChildPriceList();
              this.loadingvmodel = false;
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-AddChildPrices";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 = "Service Unavailable-AddChildPrices";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
      }
    },
  },
  components:{
    loadingcomp
  }
};
</script>
